import { Button, Form, Select } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addOrificeConfig } from "./ProductTypeSlice";
import { CommonContext, CommonContextType } from "../../contexts/CommonContext";
import { useSelector } from "react-redux";
import { AppState } from "../../redux/store/rootReducer";

export default function AddOrificeConfig({ productTypeId }: any): JSX.Element {
    const dispatch = useDispatch();
    const BodySizesData = useSelector((state: AppState) => state.BodySizes);
    const OrificeSizesData = useSelector((state: AppState) => state.OrificeSizes);
    const { setModelChange, messageApi, editBodySize, setEditBodySize, setModelChange1 } =
        React.useContext(CommonContext) as CommonContextType;
    const [form] = Form.useForm();
    const [bodySize_array, setBodySizeArray] = useState([{}]);
    const [orifice_array, setOrificeSizeArray] = useState([{}]);
    React.useEffect(() => {
        if (BodySizesData.BodySize.length > 0) {
            const arr = BodySizesData.BodySize.map((el: any) => ({ value: el.bodysize_value, label: el.bodysize_value }))
            setBodySizeArray(arr);
        }

        if (OrificeSizesData.length > 0) {
            let data = JSON.parse(OrificeSizesData[0].orificesize_value);
            const arr = data.map((el: any) => ({ value: JSON.stringify(el), name: JSON.stringify(el) }))
            setOrificeSizeArray(arr);
        }
        if (editBodySize?.id) {
            // form.setFieldsValue(editBodySize);
            form.setFieldsValue(Object.assign({ body_sizes: editBodySize?.body_size }, { orifice_sizes: editBodySize?.orifice_size?.id }, editBodySize))
        }
        else {
            form.resetFields();
        }
    }, [editBodySize, form]);

    const onFinish = (values: any) => {
        values.body_size = values.body_sizes
        values.orifice_size = Number(values.orifice_sizes)
        values.product_type = productTypeId

        delete (values.body_sizes)
        delete (values.orifice_sizes)
        /* if (productTypeId) {
            values.updated_datetime = new Date().toLocaleString() + "";
            dispatch(modifyOrificeConfig(values, editBodySize?.id));

        } else { */
        values.updated_datetime = "";
        values.created_datetime = new Date().toLocaleString() + "";
        dispatch(addOrificeConfig(values));
        // }
        setModelChange1(false);
        // setModelChange(false);
        // setEditBodySize(null);
        form.resetFields();
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return (
        <Form
            form={form}
            layout={"vertical"}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
        >

            <Form.Item
                label="Body Size"
                name="body_sizes"
                rules={[
                    {
                        required: true,
                        message: "Please select Body Size",
                    }
                ]}
            >
                <Select
                    // style={{ width: 120 }}
                    options={bodySize_array}
                />
            </Form.Item>

            <Form.Item
                label="Orifice Size"
                name="orifice_sizes"
                rules={[
                    {
                        required: true,
                        message: "Please enter Orifice Size",
                    }
                ]}
            >
                <Select
                    // style={{ width: 120 }}
                    options={orifice_array}
                />
            </Form.Item>

            <Form.Item>
                <Button style={{ backgroundColor: '#018B98', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} type="primary" htmlType="submit" > Create </Button>
            </Form.Item>
        </Form>
    );
}
